// extracted by mini-css-extract-plugin
module.exports = {"ratingValue":"AllFiltersModal_ratingValue__LluaE","difficultySubtitle":"AllFiltersModal_difficultySubtitle__Ui4J9"};